import { defineMessages } from "react-intl";

export const scope = "components.HisotryDetailsPaymentsWithholding";

export const messages = defineMessages({
  copySuccess: {
    id: `${scope}.copySuccess`,
    defaultMessage: "Copiado con exito",
  },

  statusInProgress: {
    id: `${scope}.statusInProgress`,
    defaultMessage: "Pendiente",
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: "Estado",
  },
  movementId: {
    id: `${scope}.movementId`,
    defaultMessage: "Id de movimiento",
  },
  adjustmentAmount: {
    id: `${scope}.adjustmentAmount`,
    defaultMessage: "Monto",
  },
  purchaseAmount: {
    id: `${scope}.purchaseAmount`,
    defaultMessage: "Monto de la compra",
  },
  approved: {
    id: `${scope}.approved`,
    defaultMessage: "Aprobado",
  },
  rejected: {
    id: `${scope}.rejected`,
    defaultMessage: "Rechazado",
  },
  details: {
    id: `${scope}.details`,
    defaultMessage: "Detalle",
  },
  alias: {
    id: `${scope}.alias`,
    defaultMessage: "Alias",
  },
  withholding: {
    id: `${scope}.withholding`,
    defaultMessage: "Retenciones",
  },
  retainedWithholding: {
    id: `${scope}.retainedWithholding`,
    defaultMessage: "Retenido",
  },
  baseWithholding: {
    id: `${scope}.baseWithholding`,
    defaultMessage: "Base imponible",
  },
  aliWithholding: {
    id: `${scope}.aliWithholding`,
    defaultMessage: "Alicuota",
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: "Descripcion",
  },
});
